<div class="quill-container" [ngClass]="{noTranslation: !mainLanguageContent}">
  <div *ngIf="mainLanguageContent" class="disclaimer">{{'general.deeplDisclaimer' | translate}}</div>
  <button *ngIf="mainLanguageContent" (click)="translateContent()" class="translate" mat-icon-button
          [matTooltip]="'dynamicContent.translateFromMain' | translate"><mat-icon>translate</mat-icon>
  </button>
  <button *ngIf="superadmin" (click)="showHTMLPreview()" class="sourcecode" mat-icon-button><mat-icon>tag</mat-icon>
  </button>
  <quill-editor #editor (onContentChanged)="onChange($event)" (onEditorCreated)="onEditorCreated($event)" [modules]="config"
                (onSelectionChanged)="onEditorBlurred($event)" [(ngModel)]="content" [placeholder]="'general.textPlaceholder' | translate"
                [style]="{ height: this.height, color: 'black', background: 'white', width: '100%' }">
  </quill-editor>
</div>
